import type { ReactNode } from 'react';
import React from 'react';
import { type ConnectedProps, connect } from 'react-redux';

import type { RootState } from 'reducers/types';
import { isCAP } from 'selectors';

type PropsFromRedux = ConnectedProps<typeof connector>;

type IsNotCAPComponentProps = PropsFromRedux & {
  children: ReactNode;
};

const IsNotCAPComponent = ({
  children = null,
  isCAP = false,
}: IsNotCAPComponentProps) => (isCAP ? null : <>{children}</>);

const mapStateToProps = (state: RootState) => ({
  isCAP: isCAP(state),
});

const connector = connect(mapStateToProps);
const IsNotCAP = connector(IsNotCAPComponent);

export { IsNotCAP };
